export default __webpack_public_path__ + "static/media/lightthepath.85a3ca05.png";